/**
 * Leave Request create - sample data for auto-fill.
 * Dates are computed relative to "today" so samples stay valid.
 */

import { formatDateForInput } from "@/shared/lib/date-time";

export type LeaveRequestCreateFormSample = {
  startDate: string; // YYYY-MM-DD
  endDate: string; // YYYY-MM-DD
  reason: string;
};

function addDays(d: Date, days: number): Date {
  const out = new Date(d);
  out.setDate(out.getDate() + days);
  return out;
}

/** Next weekday (skip weekend). */
function nextWeekday(d: Date): Date {
  const out = new Date(d);
  out.setDate(out.getDate() + 1);
  while (out.getDay() === 0 || out.getDay() === 6) {
    out.setDate(out.getDate() + 1);
  }
  return out;
}

export function getLeaveRequestCreateFormSamples(): LeaveRequestCreateFormSample[] {
  const today = new Date();
  const tomorrow = addDays(today, 1);
  const startNextWeek = nextWeekday(addDays(today, 7));
  const endNextWeek = addDays(startNextWeek, 2);

  return [
    {
      startDate: formatDateForInput(tomorrow),
      endDate: formatDateForInput(tomorrow),
      reason: "ປ່ວຍ",
    },
    {
      startDate: formatDateForInput(startNextWeek),
      endDate: formatDateForInput(endNextWeek),
      reason: "ພັກພະຈົນ",
    },
    {
      startDate: formatDateForInput(tomorrow),
      endDate: formatDateForInput(addDays(tomorrow, 2)),
      reason: "ລາກິດ 3 ວັນ",
    },
    {
      startDate: formatDateForInput(startNextWeek),
      endDate: formatDateForInput(addDays(startNextWeek, 4)),
      reason: "ລາພັກຄອບຄົວ",
    },
  ];
}
